import React, { useState } from "react";
import { MainModal } from "../modal/MainModal";
import { Input, FileInput } from "../form/Input/Input";

const ImageUploadModal = ({ isOpen, onClose, onSave, maxWidth }) => {
  const [imageData, setImageData] = useState(null);
  const [width, setWidth] = useState("");
  const [height, setHeight] = useState("");
  const [naturalWidth, setNaturalWidth] = useState(0);
  const [naturalHeight, setNaturalHeight] = useState(0);

  // Handle file selection
  const handleFileChange = (selectedFile) => {
    if (!selectedFile) return;

    // Read file, then capture natural dimensions once the image decodes.
    // Handlers are attached before src/readAsDataURL so a fast (cached/data-URI)
    // decode can't fire load before we're listening.
    const reader = new FileReader();

    reader.onload = (event) => {
      const img = new Image();

      img.onload = () => {
        setNaturalWidth(img.width);
        setNaturalHeight(img.height);

        // Suggest dimensions capped at the notification area width
        const suggestedWidth = Math.min(img.width, maxWidth);
        const suggestedHeight = Math.round((suggestedWidth / img.width) * img.height);

        setWidth(suggestedWidth.toString());
        setHeight(suggestedHeight.toString());
      };

      img.src = event.target.result;
      setImageData(event.target.result);
    };

    reader.readAsDataURL(selectedFile);
  };

  // Handle save
  const handleSave = () => {
    if (!imageData || !width || !height) return;

    onSave({
      url: imageData,
      width: `${width}px`,
      height: Number(width) > maxWidth ? "auto" : `${height}px`
    });

    onClose();
  };

  // Handle cancel
  const handleCancel = () => {
    onClose();
  };

  return (
    <MainModal
      isOpen={isOpen}
      headerText="Insert Image"
      parentSelector=".notifications"
      containerClassName="image-upload-modal"
      headerCloseHandler={handleCancel}
      width={500}
      height="auto"
      primaryButtonText="Save"
      primaryBtnHandler={handleSave}
      secondaryBtnText="Cancel"
      secondaryBtnHandler={handleCancel}
      onClose={handleCancel}
      primaryButtonDisabled={!imageData || !width || !height}
    >
      <div className="image-upload-modal__field">
        <FileInput
          label="Select Image"
          onChange={handleFileChange}
          customProps={{ accept: "image/*" }}
          htmlFor="image-file"
        />
      </div>

      {imageData && (
        <div className="image-upload-modal__dimensions">
          <div className="image-upload-modal__dimension">
            <Input
              label="Width (px)"
              value={width}
              onChange={setWidth}
              inputType="number"
              customProps={{ min: "1", max: maxWidth }}
              htmlFor="image-width"
            />
            <small className="image-upload-modal__hint">
              Natural: {naturalWidth}px, Max: {maxWidth}px
            </small>
          </div>

          <div className="image-upload-modal__dimension">
            <Input
              label="Height (px)"
              value={height}
              onChange={setHeight}
              inputType="number"
              customProps={{ min: "1" }}
              htmlFor="image-height"
            />
            <small className="image-upload-modal__hint">Natural: {naturalHeight}px</small>
          </div>
        </div>
      )}
    </MainModal>
  );
};

export default ImageUploadModal;
